import React from 'react';
import { Row, CardBody } from 'reactstrap';
import { HorizontalBar } from 'react-chartjs-2';
import {
  BaseCardChartContainer,
  BaseChartCardHeaderContainer,
  BaseColContainer
} from './common-charts-styles';

import { HorizontalChartContainer } from './horizontal-bar-char-styled';

export function HorizontalBarChart({ title, data }) {
  if (!data) {
    return null;
  }

  const { labels, data: chartData, colors, labelFromUsers } = data;

  const truncateLabel = (label, max = 20) => {
    if (!label) return '';
    const str = String(label);
    return str.length > max ? `${str.slice(0, max - 1)}…` : str;
  };

  const formattedLabel = labelFromUsers
    ? labels.map((label) => truncateLabel(label))
    : labels;

  const formattedData = {
    labels: formattedLabel,
    datasets: [
      {
        data: chartData,
        backgroundColor: colors
      }
    ]
  };

  const options = {
    indexAxis: 'y',
    maintainAspectRatio: true,
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          stepSize: 5
        }
      }
    },
    responsive: true,
    plugins: {
      zoom: {
        pan: {
          enabled: true,
          mode: 'y'
        },
        zoom: {
          enabled: true,
          mode: 'y'
        }
      }
    }
  };

  return (
    <BaseCardChartContainer>
      <BaseChartCardHeaderContainer>
        <h5 className="h3 mb-0">{title}</h5>
      </BaseChartCardHeaderContainer>
      <CardBody>
        <Row>
          <BaseColContainer>
            <HorizontalChartContainer className="chart">
              <HorizontalBar data={formattedData} options={options} />
            </HorizontalChartContainer>
          </BaseColContainer>
        </Row>
      </CardBody>
    </BaseCardChartContainer>
  );
}
